<p-toast></p-toast>
<app-loading-overlay></app-loading-overlay>
<div class="flex w-full min-h-screen bg-background-1">
    <app-side-menu></app-side-menu>

    <div class="flex flex-col min-w-0 lg:ml-[256px] lg:w-[calc(100%-256px)]">
        <app-header></app-header>

        <main class="p-6">
            <router-outlet></router-outlet>
        </main>
    </div>
</div>
